import { render } from "./OnzeMixed.vue?vue&type=template&id=54ca44b4"
import script from "./OnzeMixed.vue?vue&type=script&lang=js"
export * from "./OnzeMixed.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__